<script setup>
import { usePageTitle } from '~/composables/usePageTitle'
import CustomModal from "~/components/UI/CustomModal.vue"
import AppToast from "~/components/AppToast.vue"

// Establecer el título de la página automáticamente
usePageTitle()

// Inicializar WebSocket para notificaciones en tiempo real
useSocket()
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <CustomModal />
  <AppToast />
</template>
